import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError as observableThrowError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { BaseApiService } from '../../base-service/base-api.service';
import { AuditLogModel } from '../../models/logging/auditLog.model';
import { ErrorLogModel } from '../../models/logging/errorLog.model';

@Injectable()
export class LoggingService extends BaseApiService {
    auditLog(log: AuditLogModel) {
        return this.post('Foundation/Logging/Audit', log, this.replacer).pipe(
            catchError((error) => this.handleError(error)));
    }

    logException(log: ErrorLogModel) {
        return this.post('Foundation/Logging/Exception', log, this.replacer).pipe(
            catchError((error) => this.handleError(error)));
    }

    private handleError(error: HttpErrorResponse) {
        if (error.error) {
            var errorObject = {
                httpStatus: error.status,
                response: error.error
            };
            return observableThrowError(errorObject);
        } else {
            return observableThrowError('Server error');
        }
    }

    private replacer(key, value) {
        if (value === '') {
            return undefined;
        }

        return value;
    }
}
